import React, { useCallback, useState } from 'react';
import { setLiteracyResult, hideLiteracyModal } from 'actions/app-state';
import { useDispatch } from 'react-redux';
import LitImage from 'style/imgs/literacy/literacy-check.png';
import LitImageFinger from 'style/imgs/literacy/literacy-check1.png';
import LitImageUnion from 'style/imgs/literacy/union.png';
import WrongLeft from 'style/imgs/literacy/wrong-left.png';
import WrongMid from 'style/imgs/literacy/wrong-mid.png';
import WrongRight from 'style/imgs/literacy/wrong-right.png';
import DecoImage from 'style/imgs/forgotimg.png';
import Close from 'style/imgs/icons/close-icon.svg';
import styles from './index.module.scss';
import buttons from '../../../style/buttons.module.scss';

let countDownTimeout: NodeJS.Timeout | undefined;
let countDownSkipped = false;

export default function LiteracyModal(): JSX.Element {
  const dispatch = useDispatch();
  const [isValid, setValid] = useState(true);
  const [result, setResult] = useState('true');

  const clearCountDown = () => {
    if (countDownTimeout) {
      clearTimeout(countDownTimeout);
      countDownTimeout = undefined;
    }
  };

  const onSubmit = useCallback(() => {
    const answerCorrect = result === '6';

    if (answerCorrect) {
      dispatch(setLiteracyResult(true));
      countDownSkipped = false;
    } else {
      setValid(false);
    }
  }, [dispatch, result]);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onSubmit();
    }
  };

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    clearCountDown();
    countDownSkipped = true;

    clearInterval();
    setResult(e.target.value);
  }, []);

  const cancel = useCallback(() => {
    clearCountDown();
    countDownSkipped = false;
    dispatch(hideLiteracyModal());
  }, [dispatch]);

  // Hide modal autmatically after 15 sec if user didn't interracted with modal
  if (!countDownTimeout && !countDownSkipped) {
    const durationSec = 15;
    countDownTimeout = setTimeout(() => {
      clearCountDown();
      dispatch(hideLiteracyModal());
    }, durationSec * 1000);
  }

  return (
    <div className={styles.root}>
      <div className={styles.layer} />
      <div className={styles.formWrapper}>
        <div className={styles.formDecoration}>
          <img src={DecoImage} alt="" />
        </div>
        <button type="button" className={styles.formClose} onClick={cancel}>
          <img src={Close} alt="" />
        </button>

        {isValid ? (
          <div>
            <h2 className="deep-gray-heading bold">Answer the question</h2>
            <p>How many fingers do you see on the picture?</p>
            <div className={styles.formContent}>
              <img src={LitImage} alt="" />
              <img src={LitImageUnion} alt="" />
              <img src={LitImageFinger} alt="" />
            </div>
            <div className={styles.inputWrapper}>
              <input
                type="text"
                placeholder="Enter the number"
                onChange={onChange}
                onKeyDown={handleKeyDown}
              />
              <button
                type="button"
                className={buttons.buttomPrimary}
                onClick={onSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        ) : (
          <div>
            <h2 className="deep-gray-heading bold">Answer is wrong :(</h2>
            <p>Sorry your answer was wrong, make another try.</p>
            <div className={styles.wrongContent}>
              <img src={WrongLeft} alt="" />
              <img src={WrongMid} alt="" />
              <img src={WrongRight} alt="" />
            </div>
            <div className={styles.buttonWrapper}>
              <button
                type="button"
                className={buttons.buttomPrimary}
                onClick={() => setValid(true)}
              >
                Try again
              </button>
              <button
                type="button"
                className={styles.buttonCancel}
                onClick={cancel}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
